import { useMemo } from 'react';
import { useGetBusinessAddons } from '@/apis/business/addons/hook';
import { isAddonActive } from '@/pages/Business/Setting/Addons/components/addonDisplay';

export function useAiWorkflowAddonActive() {
  const { data, isLoading } = useGetBusinessAddons();

  return useMemo(() => {
    const addon = (data?.data ?? []).find((item) => item.code === 'ai_workflow');
    return {
      isLoading,
      aiWorkflowPresent: Boolean(addon),
      aiWorkflowActive: Boolean(addon && isAddonActive(addon))
    };
  }, [data?.data, isLoading]);
}
